export default __webpack_public_path__ + "static/media/banner-top-gh.b5519b95.webp";